var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { IDENTIFIERS } from '../../types/Identifiers';
import { updateValueByIdentifier } from '../../tags/values/update-by-identifier';
import { get, getRawValue } from '../../utils/get';
import { buildOgImagePreviewUrl } from '../../utils/build-og-image-preview';
import { getKeys, siteIDs, hasMissingSchemaVariables, } from '../../adapters/utils';
import { getPostFullUrl } from './calculated/get-post-full-url';
import { getCurrentLanguage } from './calculated/getCurrentLanguage';
import { getMultilingualTags } from '../../renderer/get-multilingual-tags';
export var IDs = {
    INDEX_POST: 'blog-post.index',
    TITLE: 'blog-post.title',
    HEADLINE: 'blog-post.headline',
    DESCRIPTION: 'blog-post.description',
    POST_PAGE_URL: 'blog-post.url',
    COVER_IMAGE: 'blog-post.cover.image',
    COVER_IMAGE_HEIGHT: 'blog-post.cover.image.height',
    COVER_IMAGE_WIDTH: 'blog-post.cover.image.width',
    AUTHOR: 'blog-post.author',
    AUTHOR_IMAGE_URL: 'blog-post.author.image.url',
    AUTHOR_IMAGE_HEIGHT: 'blog-post.author.image.height',
    AUTHOR_IMAGE_WIDTH: 'blog-post.author.image.width',
    PUBLISHER_ID: 'blog-post.publisher.id',
    PUBLISHER_NAME: 'blog-post.publisher.name',
    PUBLISH_DATE: 'blog-post.publish.date',
    LAST_MODIFIED_DATE: 'blog-post.modified.date',
    EXCERPT: 'blog-post.excerpt',
    AMP_URL: 'blog-post.amp.url',
    DISABLE_SCHEMA: 'blog-post.disable-schema',
    DISABLE_AMP: 'blog-post.disable-amp',
    CATEGORIES: 'blog-post.categories',
    SD_DISABLE_SCHEMA: 'blog-post.disable-schema',
};
var userVisible = [
    IDs.TITLE,
    IDs.POST_PAGE_URL,
    IDs.COVER_IMAGE,
    IDs.AUTHOR,
    IDs.LAST_MODIFIED_DATE,
    IDs.PUBLISH_DATE,
    IDs.EXCERPT,
];
var userVisibleSdOnly = [
    IDs.CATEGORIES,
    IDs.HEADLINE,
    IDs.DESCRIPTION,
    IDs.COVER_IMAGE_WIDTH,
    IDs.COVER_IMAGE_HEIGHT,
    IDs.AUTHOR_IMAGE_URL,
    IDs.AUTHOR_IMAGE_WIDTH,
    IDs.AUTHOR_IMAGE_HEIGHT,
];
var requiredSchemaVariables = [siteIDs.BUSINESS_LOGO, siteIDs.SITE_NAME];
var SchemaTypes = {
    BLOG_POST_BLOG_POSTING: 'blog-post-blog-posting-preset',
    BLOG_POST_NEWS_ARTICLE: 'blog-post-news-article-preset',
    BLOG_POST_ARTICLE: 'blog-post-article-preset',
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    requiredSchemaVariables: requiredSchemaVariables,
    getData: function (item) {
        var _a;
        var data = (_a = {},
            _a[IDs.INDEX_POST] = getRawValue(item, "post.noIndex") ? 'noindex' : '',
            _a[IDs.TITLE] = get(item, 'post.title'),
            _a[IDs.HEADLINE] = get(item, 'post.title').substring(0, 110),
            _a[IDs.DESCRIPTION] = get(item, 'post.description'),
            _a[IDs.POST_PAGE_URL] = getPostFullUrl(item),
            _a[IDs.COVER_IMAGE] = buildOgImagePreviewUrl({
                url: get(item, 'post.image.url'),
                width: get(item, 'post.image.width'),
                height: get(item, 'post.image.height'),
            }),
            _a[IDs.COVER_IMAGE_HEIGHT] = get(item, 'post.image.height'),
            _a[IDs.COVER_IMAGE_WIDTH] = get(item, 'post.image.width'),
            _a[IDs.AUTHOR] = get(item, 'post.owner.name'),
            _a[IDs.AUTHOR_IMAGE_URL] = buildOgImagePreviewUrl({
                url: get(item, 'post.owner.image.url'),
                height: get(item, 'post.owner.image.height'),
                width: get(item, 'post.owner.image.width'),
            }),
            _a[IDs.AUTHOR_IMAGE_HEIGHT] = get(item, 'post.owner.image.height'),
            _a[IDs.AUTHOR_IMAGE_WIDTH] = get(item, 'post.owner.image.width'),
            _a[IDs.PUBLISHER_ID] = get(item, 'post.publisher.id'),
            _a[IDs.PUBLISHER_NAME] = get(item, 'post.publisher.name'),
            _a[IDs.PUBLISH_DATE] = get(item, 'post.firstPublishedDate'),
            _a[IDs.LAST_MODIFIED_DATE] = get(item, 'post.lastPublishedDate'),
            _a[IDs.EXCERPT] = get(item, 'post.excerpt'),
            _a[IDs.AMP_URL] = get(item, 'post.amphtml'),
            _a[IDs.DISABLE_SCHEMA] = !getRawValue(item, 'postsSettings.isSchemaEnabled'),
            _a[IDs.DISABLE_AMP] = !getRawValue(item, 'postsSettings.isAmpEnabled'),
            _a[IDs.CATEGORIES] = get(item, 'post.categories'),
            _a[IDs.SD_DISABLE_SCHEMA] = hasMissingSchemaVariables(requiredSchemaVariables, item),
            _a);
        return data;
    },
    getLegacySeoBlob: function (item) {
        var tags = updateValueByIdentifier([], IDENTIFIERS.TITLE, get(item, 'legacySeoData.title'));
        tags = updateValueByIdentifier(tags, IDENTIFIERS.DESCRIPTION, get(item, 'legacySeoData.description'));
        return { tags: tags };
    },
    getBiData: function () {
        return {};
    },
    getDynamicPatternsSchema: function (item) {
        var translatedPages = getRawValue(item, 'translatedPages') || [];
        var hasTranslations = Boolean(translatedPages.length);
        var currentLanguageCode = getCurrentLanguage(item);
        var currentUrl = getPostFullUrl(item);
        var isIndexed = !getRawValue(item, 'post.noIndex');
        if (!item || !hasTranslations || !isIndexed) {
            return { tags: [] };
        }
        var siteUrl = get(item, 'context.siteUrl');
        var tags = getMultilingualTags(__spreadArrays([
            { url: currentUrl, langCode: currentLanguageCode }
        ], translatedPages, [
            { url: siteUrl, langCode: 'x-default' },
        ]));
        return { tags: tags };
    },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return getKeys(IDs, userVisibleSdOnly); },
    getSlug: function (item) { return get(item, 'post.slug'); },
    setFullUrl: function (item, url) {
        if (url === void 0) { url = ''; }
        item = JSON.parse(JSON.stringify(item));
        item.post.path = url;
        return item;
    },
    getFullUrl: function (item) { return getPostFullUrl(item); },
    updateItemDataWithSlug: function (item) { return item; },
};
